var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export default (function (props) {
  return React.createElement(SvgIcon, _extends({
    viewBox: '0 0 32 38'
  }, props), React.createElement('path', {
    d: 'M18.272 16l5.248-5.28c0.32-0.288 0.48-0.672 0.48-1.12 0-0.896-0.704-1.6-1.6-1.6-0.448 0-0.832 0.16-1.12 0.448l-5.28 5.28-5.248-5.28c-0.288-0.288-0.704-0.448-1.152-0.448-0.864 0-1.6 0.704-1.6 1.6 0 0.448 0.192 0.832 0.48 1.12l5.28 5.28-5.28 5.248c-0.288 0.288-0.48 0.704-0.48 1.152 0 0.864 0.736 1.6 1.6 1.6 0.448 0 0.864-0.192 1.152-0.48l5.248-5.28 5.28 5.28c0.288 0.288 0.672 0.48 1.12 0.48 0.896 0 1.6-0.736 1.6-1.6 0-0.448-0.16-0.864-0.448-1.152l-5.28-5.248z'
  }));
});